import { t } from "ttag";

import { useMessenger } from "@/app/hooks/use-messenger";
import type { ModalProps } from "@/shared/models/legacy-types";
import { Button, Dialog, ShieldWarningIcon } from "@/shared/ui";

export const UrgentCareModal = ({ show, onClose }: ModalProps) => {
  const {
    actions: { showMessenger },
  } = useMessenger();

  const handleContactSupport = () => {
    onClose();
    showMessenger();
  };

  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content>
        <Dialog.Header icon={ShieldWarningIcon}>
          <Dialog.Title>{t`You might need urgent care`}</Dialog.Title>
          <Dialog.Description>
            {t`It seems your needs require more specialized attention than what we currently offer. Please seek care immediately at the nearest ER or urgent care in your community for the specific assistance you require.`}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button size="lg" onClick={handleContactSupport}>
            {t`Contact LevelsRx support`}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
